import { IAppState } from '../../redux';
import { selectServiceById } from './selectServiceById';
import { EUnavailableReason } from '../../redux/reducers';
import { selectActiveOrPromotionServiceId } from './selectActiveOrPromotionServiceId';
import { selectIsServicesEnabled } from './selectIsServicesEnabled';

export function selectServiceUnavailableReason(state: IAppState): EUnavailableReason | null {
  const serviceId = selectActiveOrPromotionServiceId(state);
  const isServicesEnabled = selectIsServicesEnabled(state);

  if (!serviceId || !isServicesEnabled) {
    return null;
  }

  const service = selectServiceById(serviceId, state);

  if (!service) {
    return null;
  }

  return service.unavailableReasonType;
}
